import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/speakap': {
    width: 430,
    height: 512,
    paths: [
      {
        d: 'M55 391.8C-24.4 303.6-16.9 167.4 71.7 87.6S296.5 14.7 375.9 102.9 447.8 327.2 359.2 407C340.5 423.9 423.3 450.1 401.2 459.3 319.2 493.5 147.3 494.3 55 391.8zM268.3 180.2L306.8 139.3C297.2 130.4 274.8 112.5 230.7 111.7 178.3 110.8 134.8 140 133.9 191.7 133.7 203 134.2 228.4 163.3 246.5 197.8 267.9 249.8 268 249.3 298.8 248.9 320 222.9 324.6 210.7 324.4 207.7 324.3 180.5 323.9 163.1 299.8L123.1 342.4C151.3 369.4 182.1 375 206.6 375.4 216.8 375.6 303 375.7 304.5 294.4 304.7 278.6 302.4 254.7 275.6 237.8 241.2 216.2 190.6 218.4 191.2 188.1 191.6 164.8 222.1 162.7 228.7 162.8 229.1 162.8 255.3 163.1 268.3 180.2z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/speakap.js
// module id = x6HL
// module chunks = 144